import React, {useCallback, useEffect, useState} from 'react';
import PageButton from "../elements/PageButton/PageButton";
import {
  exitFullscreen,
  FULLSCREEN_CHANGE_EVENTS,
  getFullscreenElement,
  isFullscreenSupported,
  requestFullscreen
} from "../../utils/fullscreen";

/**
 * Кнопка переключения полноэкранного режима (настройки и игровое меню).
 *
 * Нужна и в установленном PWA: манифест открывает приложение в
 * display: standalone, где нижняя панель навигации Android висит постоянно,
 * и убирает ее только Fullscreen API. При старте режим включается автоматом
 * (см. App.js), но после явного выхода кнопкой «Назад» автозапрос намеренно
 * не навязывается снова — эта кнопка и есть ручной возврат.
 *
 * Не отображается там, где Fullscreen API недоступен: на iPhone WebKit
 * умеет разворачивать только <video>, и нажатие на кнопку не давало ровно
 * ничего.
 */
const FullscreenToggleButton = ({className, children, ...rest}) => {
  const [isFullscreen, setIsFullscreen] = useState(() => !!getFullscreenElement());

  useEffect(() => {
    const handleChange = () => setIsFullscreen(!!getFullscreenElement());
    FULLSCREEN_CHANGE_EVENTS.forEach((eventName) =>
      document.addEventListener(eventName, handleChange));
    return () => FULLSCREEN_CHANGE_EVENTS.forEach((eventName) =>
      document.removeEventListener(eventName, handleChange));
  }, []);

  const handleClick = useCallback((e) => {
    if (getFullscreenElement()) {
      exitFullscreen().catch(() => {
      });
    } else {
      requestFullscreen(document.documentElement).catch(() => {
      });
    }

    if (rest.onClick) rest.onClick(e);
  }, [rest]);

  // Проверка ПОСЛЕ всех хуков — ранний выход выше сломал бы их порядок.
  // Поддержка API за время сессии не меняется, поэтому подписка не нужна
  if (!isFullscreenSupported()) {
    return null;
  }

  return (
    <PageButton {...rest} buttonId={'full_screen'} className={className} onClick={handleClick}>
      {children || (isFullscreen ? 'Выйти из полного экрана' : 'На весь экран')}
    </PageButton>
  );
};

export default FullscreenToggleButton;
